import React, { useRef, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../Assets/NipponSplashLogo.png';
import { FaHome, FaBars, FaTimes, FaSignOutAlt, FaCheckCircle, FaUser, FaArrowCircleLeft,FaWhmcs, FaUpload, FaGift  } from 'react-icons/fa';
import './Header.css';
import { TextConstants } from '../../Constants/Constants';
import { MdCloudUpload } from 'react-icons/md';

const Header = ({title}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showProfileSidebar, setShowProfileSidebar] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const sidebarRef = useRef(null);
  const popupRef = useRef(null);


  const userinfo = JSON.parse(sessionStorage.getItem('userinfo')) || {};
  const userName = userinfo.employeeName || 'Guest';
  const userRole = userinfo.rolename || 'Unknown';
  const employeeId = userinfo.employeeId || 'N/A';

  const getInitials = (name) => {
    const names = name.split(' ');
    if (names.length > 1) {
      return names[0][0].toUpperCase() + names[1][0].toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowProfileSidebar(false);
        setShowDropdown(false);
      }
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowLogoutConfirm(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    setShowLogoutConfirm(true);
    setShowProfileSidebar(false)
  };

  const handleHomePress = () => {
    navigate('/dashboard');
  };

  const handleMenuPress = () => {
    navigate('/approval');
  };

  const handleProcessOrder = () => {
    navigate('/processOrder');
  };

  const handleFileUpload = () => {
    navigate('/ScannedFileUpload');
  };

  const handleScheme = () => {
    navigate('/Scheme');
  };

  const handleProfilePress = () => {
    setShowDropdown(!showDropdown);
  };

  const confirmLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  const handlebackpress =() => {
    navigate(-1);
  }

  return (
    <header className="header-nav">
      <div className="logo">
        <img src={logo} alt="Logo" className="logo-image" />
      </div>
      <div> <h2>{title}</h2></div>
      <div className="nav-right">
        {location.pathname !== '/dashboard' && (
          <>
            <div className="profile-icon" style={{ marginRight: '20px', cursor: 'pointer' }} onClick={handlebackpress} title="back">
              <FaArrowCircleLeft size={30} />
            </div>
            <div className="profile-icon" style={{ marginRight: '20px', cursor: 'pointer' }} onClick={handleHomePress} title="Home">
              <FaHome size={30} />
            </div>
          </>
        )}
        <div className="profile-icon" style={{ cursor: 'pointer'}} onClick={() => setShowProfileSidebar(!showProfileSidebar)} title="Menu">
          <FaBars size={30} />
        </div>
        <div className={`profile-sidebar ${showProfileSidebar ? 'open' : ''}`} ref={sidebarRef}>
          <button className="close-sidebar" onClick={() => setShowProfileSidebar(false)}>
            <FaTimes size={20} color='white'/>
          </button>
          <div className="profile-header">
            <div className="profile-avatar">{getInitials(userName)}</div>
            <div className="profile-details">
              <p className="profile-username">{userName.length > 12 ? `${userName.slice(0, 10)}...` : userName}</p>
              <p className="profile-role">{userRole}</p>
            </div>
          </div>
          <hr className="profile-divider" />
          <div className="profile-actions">
          {location.pathname !== '/dashboard' &&<div className="profile-action" onClick={handleHomePress}>
              <FaHome size={24} />
              <span>{TextConstants.home}</span>
            </div>}
            <div className="profile-action" onClick={handleProfilePress}>
              <FaUser size={24} />
              <span>{TextConstants.profile}</span>
            </div>
            <div className={`dropdown-content ${showDropdown ? 'open' : ''}`}>
              <p>{TextConstants.empName}: {userName}</p>
              <p>{TextConstants.empId}: {employeeId}</p>
              <p>{TextConstants.role}: {userRole}</p>
            </div>
           
            {userRole === 'President' && (
              <div className="profile-action" onClick={handleMenuPress}>
                <FaCheckCircle size={24} />
                <span>{TextConstants.approvals}</span>
              </div>
            )}
            <div className="profile-action" onClick={handleProcessOrder}>
              <FaWhmcs size={24} />
              <span>{TextConstants.processOrderReport}</span>
            </div>
            {/* <div className="profile-action" onClick={handleFileUpload}>
              <MdCloudUpload size={24} />
              <span>{TextConstants.FileUpload}</span>
            </div> */}
            <div className="profile-action" onClick={handleScheme}>
              <FaGift size={24} />
              <span>{TextConstants.scheme}</span>
            </div>
            <div className="profile-action" onClick={handleLogout}>
              <FaSignOutAlt size={24} />
              <span>{TextConstants.logout}</span>
            </div>
          </div>
        </div>
      </div>
      {showLogoutConfirm && (
        <div className="logout-confirm-popup" ref={popupRef}>
          <p style={{color:'black'}}>{TextConstants.logoutAlert}</p>
          <button onClick={confirmLogout}>{TextConstants.yes}</button>
          <button onClick={cancelLogout}>{TextConstants.no}</button>
        </div>
      )}
    </header>
  );
};

export default Header;
